import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
	selector: 'app-address-compare-card',
	templateUrl: './address-compare-card.component.html',
	styleUrls: ['./address-compare-card.component.scss'],
})
export class AddressCompareCardComponent implements OnInit {
	@Input() title: string;
	@Input() address: FullAddress;
	@Input() selected: boolean;
	@Input() gtmEventData: any;
	@Output() cardSelected: EventEmitter<FullAddress> = new EventEmitter<FullAddress>();

	constructor() {}

	ngOnInit() {}

	onCardSelected(): void {
		this.cardSelected.emit(this.address);

		if (Object.keys(this.gtmEventData).length > 0) {
		}
	}
}
